var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterDescending = function SvgFilterDescending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M18.395 1.673c0-.112 0-.336-.112-.449S18.059 1 17.834 1H1.561c-.112 0-.337.112-.449.224C1 1.337 1 1.45 1 1.674 1.224 5.6 4.142 8.855 7.958 9.641v7.631c0 .225.112.449.337.561.224.113.449.113.673-.112l2.357-1.908c.112-.112.225-.224.225-.449V9.642c3.703-.898 6.62-4.04 6.845-7.969M18 20.5l2.5 2.5 2.5-2.5M20.5 23V11"
  })));
};
export default SvgFilterDescending;